import moment from "moment";
import { dateFilters } from "../../constants";
const sortOrders = (orders) => {
    return orders === null || orders === void 0 ? void 0 : orders.sort((a, b) => {
        const aDate = a.order.OrderIsUpcoming ? moment(a.order.ForWeekStartingOn) : moment(a.orderInfo.order_date);
        const bDate = b.order.OrderIsUpcoming ? moment(b.order.ForWeekStartingOn) : moment(b.orderInfo.order_date);
        if (aDate.isBefore(bDate)) {
            return -1;
        }
        else if (aDate.isAfter(bDate)) {
            return 1;
        }
        else {
            return 0;
        }
    });
};
// #  Start Date    End Date    Upcoming     Past 3M/6M/1Y    All Time
// ─────────────────────────────────────────────────────────────────────
// 1  FUTURE        FUTURE      display      NO display       display
// 2  PAST          FUTURE      display      display          display
// 3  PAST          PAST        NO display   display          display
// 4  Today         Today       display      display          display
// 5  Today         FUTURE      display      display          display
export const processOrders = (orders, dateFilter) => {
    if (!orders) {
        return [];
    }
    // Past 3M / 6M / 1Y: exclude orders whose StartDate has not yet occurred (Scenario 1)
    if (dateFilter !== dateFilters.upcoming && dateFilter !== dateFilters.allTime) {
        return orders.filter((o) => moment(o.order.StartDate).isSameOrBefore(moment(), "day"));
        // Upcoming: exclude orders whose EndDate has already passed
    }
    else if (dateFilter === dateFilters.upcoming) {
        return orders.filter((o) => { var _a; return !((_a = o.order) === null || _a === void 0 ? void 0 : _a.EndDate) || moment(o.order.EndDate).isSameOrAfter(moment(), "day"); });
    }
    // All Time: no additional filtering needed
    return sortOrders(orders);
};
